import React from 'react'

import { Display, Strong, Text } from '@gousto-internal/citrus-react'

import { useNumPortions } from 'hooks/basket/useNumPortions'
import { useMaxRecipesForPortion } from 'hooks/menu-boxes/useMaxRecipesForPortion'
import { useMinRecipesForPortion } from 'hooks/menu-boxes/useMinRecipesForPortion'

type TreatmentProgressMessageProps = {
  numRecipes: number
}

const TreatmentProgressMessage = ({ numRecipes }: TreatmentProgressMessageProps) => {
  const { numPortions } = useNumPortions()
  const minRecipesNum = useMinRecipesForPortion(numPortions)
  const maxRecipesNum = useMaxRecipesForPortion(numPortions)

  if (numRecipes <= 0) {
    return (
      <Text display={Display.Inline} size={0}>
        Add <Strong>{maxRecipesNum}</Strong> recipes for the best price per serving
      </Text>
    )
  }

  if (numRecipes < minRecipesNum) {
    return (
      <Text display={Display.Inline} size={0}>
        Add more recipes to complete your box
      </Text>
    )
  }

  if (numRecipes >= maxRecipesNum) {
    return (
      <Text display={Display.Inline} size={0}>
        Nice! You&apos;ve got the best price per serving
      </Text>
    )
  }

  const remainingRecipes = maxRecipesNum - numRecipes

  return (
    <Text display={Display.Inline} size={0}>
      Add <Strong>{remainingRecipes}</Strong> more recipe
      {remainingRecipes > 1 ? 's' : ''} for the best price per serving
    </Text>
  )
}

export { TreatmentProgressMessage }
